import SSPresentationSlide from './01-slideshare_presentation_slide';

function SSVideoEmbedSlide(config){
  SSPresentationSlide.call(this, config);
  this.config = config;
  this.PLAYER_UNINITIALIZED = -1;
  /* -1 (unstarted)
  *   0 (ended)
  *   1 (playing)
  *   2 (paused)
  *   3 (buffering)
  *   5 (video cued).
  */

  this.PLAYER_AUTOHIDE = 2;
  /*  0 - Video and Progress bar visible throughout
  *   1 - Bars disapper in 2 secs, appear on hover
  *   2 - Progress bar fades out, player controls remain
  */
  this.ENABLE_JS_API = 1; // 1 or 0 indicating use of JS API.
  this.PADDING = 0;
  this.RELATED_VIDEOS = 0;  // Set to 0 to hide related videos (possible values = 0/1)
  this.playerReady = false;
  this._initVideoSlidesLoading();
}
/**
  * Deriving from Presentation slide as video will be only in
  * presentations and properties are very similar.
  * Video specific functions like +paint+ is overriden here
  */
SSVideoEmbedSlide.prototype = new SSPresentationSlide();

/**
  * setup a function when the Youtube Api is ready
  * function has to be window scope, but
  * needs to access video slide specific properties.
  * Hence capturing the video slides in global object.
  */
SSVideoEmbedSlide.prototype._initVideoSlidesLoading = function(){
  if (typeof(window.onYouTubePlayerAPIReady) !== 'function'){
    window.onYouTubePlayerAPIReady = function(){
      $(window.video_slides || []).each(function(idx, vid_slide) {
        vid_slide.playerReady = true;
      });
    };
  }
  if (!window.video_slides){
    window.video_slides = [];
  }
  window.video_slides.push(this);
};

// Once the video is ready, assign it to its corresponding +SSVideoEmbedSlide+
SSVideoEmbedSlide.prototype._videoReady = function(e) {
  this.ytube_player = e.target;
};

SSVideoEmbedSlide.prototype._playVideo = function() {
  if (this.ytube_player.getPlayerState){
    if (this.ytube_player.getPlayerState() === this.PLAYER_UNINITIALIZED) {
      this.ytube_player.playVideo();
    }
  } else {
    var that = this;
    setTimeout(function(){
      that._playVideo();
    }, 1000);
  }
};

SSVideoEmbedSlide.prototype._pauseVideo = function() {
  this.ytube_player && this.ytube_player.pauseVideo && this.ytube_player.pauseVideo();
};

SSVideoEmbedSlide.prototype._videoLoadFailed = function(e) {
  $.slideshareEventManager.trigger('videoloadfailed');
};

SSVideoEmbedSlide.prototype._tryPlayerLoad = function() {
  // Removed as part of SLDSHR-6717
};

SSVideoEmbedSlide.prototype.retryPlayerLoad = function() {
  clearTimeout(this.retrying);
  if(this.playerReady) {
    this._tryPlayerLoad();
  } else {
    var slide = this;
    this.retrying = setTimeout(function(){
      slide.retryPlayerLoad();
    }, 1000);
  }
};

SSVideoEmbedSlide.prototype.removeLoading = function() {
  var wrapper = this.currentViewMode.wrapper;
  var currentPlayer = '#ytube_player' + this.config.current_video_count;
  var currentLoading = '.ytube_message';
  $(currentPlayer, wrapper).show();
  $(currentLoading, wrapper).remove();
};

SSVideoEmbedSlide.prototype.showLoading = function(){
  var wrapper = this.currentViewMode.wrapper;
  var loading_message = this.config.loading_message_partial;
  $(loading_message).appendTo(wrapper);
  this.hideLoadingMessage = true;
};

SSVideoEmbedSlide.prototype.show = function(options) {
  this.currentViewMode.rendered = true;
  this.load();
  if(this.painted){
    this.showMessage();
  }
};


SSVideoEmbedSlide.prototype.showMessage = function(){
  if(!this.hideLoadingMessage) {
    this.showLoading();
    clearTimeout(this.removeLoadingTimeout);
    var slide = this;
    if(this.hideLoadingMessage === undefined || this.hideLoadingMessage){
      this.removeLoadingTimeout = setTimeout(function(){
        slide.removeLoading();
        // Disabling autoplay when the video slide loads
        // slide._playVideo();
      }, 3000);
    }
  } else {
    $('#ytube_player' + this.config.current_video_count).show();
  }
};

SSVideoEmbedSlide.prototype.emptySlide = function() {
  this.currentViewMode.contentElement = null;
  this.currentViewMode.rendered = false;
  this.painted = false;
  this.ytube_player = null;
};

SSVideoEmbedSlide.prototype.stop = function() {
  this._pauseVideo();
};

SSVideoEmbedSlide.prototype.load = function(){
  $.slideshareEventManager.trigger('slideloaded', { index : this.index });
};

/**
  * Updates display with Slide contents. To be called once slide has finished loading
  * Overriding here as video slide's display is different from presentation slide.
  * @private
  */
SSVideoEmbedSlide.prototype.paint = function(){
  if(this.$slide.find('.ytube-container').length === 0) {
    var i18n = slideshare_object.utils.i18n;

    // Container
    this.currentViewMode.contentElement = $('<div class="ytube-container-desktop"></div>');

    // First line - info text
    this.currentViewMode.contentElement.append($('<p class="yt-header">' + i18n("youtube_embed_block.header") + '</p>'));

    // Second line - link to video
    var anchorEl = $('<p><a href=' + 'https://www.youtube.com/watch?v=' + this.config.video_id + '>' + i18n("youtube_embed_block.link_to_original") + '</a></p>');
    this.currentViewMode.contentElement.append(anchorEl);

    // Third line - help article
    this.currentViewMode.contentElement.append($('<p class="yt-footer"><a href="https://www.linkedin.com/help/slideshare/answer/65313">' + i18n("youtube_embed_block.help_text") + '</a></p>'));

    // Set youtube container height to content height if slide container's height is zero
    this.currentViewMode.contentElement.appendTo($('<div/>')
      .addClass('ytube-container')
      .css({ 'height': this.$stage.height() || this.contentHeight })
      .appendTo(this.$slide));
  }
};

// stubbing out to avoid actions
SSVideoEmbedSlide.prototype._getNewResourceVersions = function(){
  //
};

export default SSVideoEmbedSlide;